import { compile } from 'path-to-regexp';

export const getRootDomain = (url: string, prefix: string = ''): string => {
  const { hostname } = new URL(url);
  const parts = hostname.split('.');
  const domain = parts.length > 1 ? parts.slice(-2).join('.') : hostname;
  return prefix + domain;
};

export const pathToUrl = (path: string, params: object = {}) =>
  compile(path)(params);
